import { jsxs as l, jsx as o, Fragment as C } from "react/jsx-runtime";
import { R as g, b as N, P as b, O as y, C as w, T as k, D, a as s } from "./index-DiewFMZH.js";
import { R as O } from "./index-eUKFwFOR.js";
import { c as R } from "./clsx-OuTLNxxd.js";
import { B as I } from "./button.types-CiS8pXSt.js";
import { Divider as n } from "./components/elements/divider/divider.js";
import { I as M } from "./icon-OnwLrJ7B.js";
import "./components/elements/icon/iconsList.js";
const $ = "_modal_1xhp3_1", a = {
  "modal-overlay": "_modal-overlay_1xhp3_1",
  "overlay-show": "_overlay-show_1xhp3_1",
  modal: $,
  "content-show": "_content-show_1xhp3_1",
  "desktop-content-show": "_desktop-content-show_1xhp3_1",
  "is-small": "_is-small_1xhp3_39",
  "is-medium": "_is-medium_1xhp3_42",
  "is-large": "_is-large_1xhp3_45",
  "modal-title": "_modal-title_1xhp3_53",
  "modal-divider": "_modal-divider_1xhp3_68",
  "modal-bottom": "_modal-bottom_1xhp3_71",
  "outer-modal-content": "_outer-modal-content_1xhp3_75",
  "modal-content": "_modal-content_1xhp3_84",
  "modal-actions": "_modal-actions_1xhp3_94",
  "confirm-cta": "_confirm-cta_1xhp3_103",
  "modal-close": "_modal-close_1xhp3_114"
};
function q({
  size: c = "medium",
  title: _,
  description: m,
  onClose: t,
  children: h,
  dialogTriggerNode: p,
  alternativeAction: d,
  onAlternativeAction: x,
  confirmActionText: i,
  onConfirmAction: u,
  isOpen: f,
  onChange: r
}) {
  const v = R(a.modal, a[j[c]]);
  return /* @__PURE__ */ l(g, { open: f, onOpenChange: (e) => {
    r && r(e), e === !1 && t && t(e);
  }, children: [
    /* @__PURE__ */ o(N, { asChild: !0, children: p }),
    /* @__PURE__ */ l(b, { children: [
      /* @__PURE__ */ o(y, { className: a["modal-overlay"] }),
      /* @__PURE__ */ l(w, { className: v, children: [
        /* @__PURE__ */ l("div", { children: [
          /* @__PURE__ */ o(k, { className: a["modal-title"], children: _ }),
          m && /* @__PURE__ */ o(O, { asChild: !0, children: /* @__PURE__ */ o(D, { children: m }) })
        ] }),
        /* @__PURE__ */ o(n, { className: a["modal-divider"] }),
        /* @__PURE__ */ o("div", { className: a["outer-modal-content"], children: /* @__PURE__ */ o("div", { className: a["modal-content"], children: h }) }),
        i && /* @__PURE__ */ l(C, { children: [
          /* @__PURE__ */ o(n, { className: `${a["modal-divider"]} ${a["modal-bottom"]}` }),
          /* @__PURE__ */ l("div", { className: a["modal-actions"], children: [
            d && /* @__PURE__ */ o(s, { asChild: !0, children: /* @__PURE__ */ o("button", { onClick: x, children: d }) }),
            /* @__PURE__ */ o(s, { asChild: !0, children: /* @__PURE__ */ o(
              I,
              {
                onClick: u,
                className: a["confirm-cta"],
                text: i,
                size: "regular"
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ o(s, { asChild: !0, children: /* @__PURE__ */ o("button", { className: a["modal-close"], "aria-label": "Close", children: /* @__PURE__ */ o(M, { name: "remove", size: "large" }) }) })
      ] })
    ] })
  ] });
}
const j = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
};
export {
  q as M,
  j as a
};
